import styled from "@emotion/styled";
import React from "react";

export type BgVariants =
  | "animate-primary"
  | "sunrise-light-horizontal"
  | "sunrise-light"
  | "sunrise";

const PRIMARY_GRADIENT = `linear-gradient(228deg, #ffdfb4 -16.15%, #fddee9 40.76%, #c1d7fb 94.22%)`;

const BackgroundStyle = styled.div<{ $fixed?: boolean }>`
  background-color: var(--color-cream);
  min-height: 100%;
  height: 100%;

  &.animate-primary {
    background: var(--bg-primary-gradient, ${PRIMARY_GRADIENT});
    ${({ $fixed }) =>
      $fixed &&
      `
      background-attachment: fixed;
      background-size: cover;
    `}
  }
`;

const WithBackground: React.FC<{
  children: React.ReactNode;
  variant?: BgVariants;
  fixed?: boolean;
  style?: React.CSSProperties;
  slot?: string;
}> = ({ children, variant, fixed, style, slot }) => {
  return (
    <BackgroundStyle
      slot={slot}
      className={`${variant ?? ""} bg-wrapper`}
      $fixed={fixed}
      style={style}
    >
      {children}
    </BackgroundStyle>
  );
};

export default WithBackground;
